import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loader from "../Loader";
import { subscribeToSocketMessages } from "../../api/socket/socket";

const isAdminRole = (role) => role === "admin" || role === "super_admin";

const AdminRoute = ({ children }) => {
  const { isAuthenticated, user, loading, isAuthInitializing } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    return subscribeToSocketMessages((response) => {
      console.log("[SI_SOCKET] event", response);
    });
  }, [isAuthenticated]);

  if (loading || isAuthInitializing) return <Loader />;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdminRole(user?.role)) {
    return <Navigate to="/team" replace />;
  }

  return children;
};

export default AdminRoute;
